import { createSlice } from "@reduxjs/toolkit";
import { uploadSpreadsheet } from "./UploadAction";

interface InitialState {
  upload_spreadsheet_loading: boolean;
  upload_spreadsheet_data: any;
  upload_spreadsheet_error: any | null;
}

const initialState: InitialState = {
  upload_spreadsheet_loading: false,
  upload_spreadsheet_data: null,
  upload_spreadsheet_error: null,
};

const uploadSlice = createSlice({
  name: "upload",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(uploadSpreadsheet.pending, (state) => {
      state.upload_spreadsheet_loading = true;
      state.upload_spreadsheet_data = null;
      state.upload_spreadsheet_error = null;
    });
    builder.addCase(uploadSpreadsheet.fulfilled, (state, action) => {
      state.upload_spreadsheet_loading = false;
      state.upload_spreadsheet_data = action.payload?.data;
      state.upload_spreadsheet_error = null;
    });
    builder.addCase(uploadSpreadsheet.rejected, (state, action) => {
      state.upload_spreadsheet_loading = false;
      state.upload_spreadsheet_data = null;
      state.upload_spreadsheet_error = action.payload;
    });
  },
});

const uploadReducer = uploadSlice.reducer;
export default uploadReducer;
